export class RightManagement {
  menu: RightManagementMenu;
  view?: boolean;
  viewMenuIAdmin?: boolean;
  constructor(data: Partial<RightManagement>) {
    Object.assign(this, data);
  }
}

export class RightManagementMenu {
  administration?: boolean;
  administrationSysteme?: boolean;
  classementDossiers?: boolean;
  classementDossiersPartiel?: boolean;
  codesClassement?: boolean;
  contacts?: boolean;
  flux?: boolean;
  isAdminIscan?: boolean;
  mails?: boolean;
  modelesDocuments?: boolean;
  profiles?: boolean;
  services?: boolean;
  systemParameters?: boolean;
  users?: boolean;
  constructor(data: Partial<RightManagementMenu>) {
    Object.assign(this, data);
  }
}
